var thumbs = document.getElementById("thumbnails");
var modal = document.getElementById("myModal");

thumbs.addEventListener("click", function (i) {

    if (i.target.nodeName.toLowerCase() == "img") {

		var img = document.getElementById(i.target.id);

		// Get the image and insert it inside the modal - use its "alt" text as a caption
		var modalImg = document.getElementById("img01");
		var captionText = document.getElementById("caption");

		modal.style.display = "block";
		modalImg.src = img.src;
		captionText.innerHTML = img.alt;

    }

});

modal.addEventListener("click", function (i) {

    if (i.target.nodeName.toLowerCase() == "span") {
      // When the user clicks on outside of images, close the modal
      window.modal.style.display = "none";
    }
});
  

// When the user hits the escape key, close the modal
document.onkeydown = function(evt) {
    evt = evt || window.event;
    var isEscape = false;
    if ("key" in evt) {
        isEscape = (evt.key === "Escape" || evt.key === "Esc");
    } else {
        isEscape = (evt.keyCode === 27);
    }
    if (isEscape) {
        window.modal.style.display = "none";
    }
};